module.exports = __webpack_public_path__ + "static/media/planta-final02.032ba8fa.jpg";